<div class="filters">
  <h4>{{ "WXRL.FILTERS" | translate }}</h4>
  <div class="filter-group">
    <div class="filter-item">
      <label for="laboratory">{{ "WXRL.LABORATORY" | translate }}</label>
      <p-dropdown
        id="laboratory"
        [options]="laboratories"
        [(ngModel)]="selectedLaboratory"
        (onChange)="onLaboratoryChange($event)"
        placeholder="{{ 'WXRL.LABORATORY' | translate }}"
        dataKey="labNr"
        optionLabel="labName"
        option
      ></p-dropdown>
    </div>
    <div class="filter-item">
      <label for="area">{{ "WXRL.AREA" | translate }}</label>
        <p-dropdown
          id="area"
          [options]="areas"
          [(ngModel)]="selectedArea"
          (onChange)="onAreaChange($event)"
          placeholder="{{ 'WXRL.AREA' | translate }}"
          dataKey="labBerNr"
          optionLabel="labBerName"
          [disabled]="!selectedLaboratory || !requiresArea || shouldDisableAreaAndStatus"
          [showClear]="true"
        ></p-dropdown>
    </div>
    <!-- status -->
    <div class="filter-item">
      <label for="status">{{ "WXRL.STATUS" | translate }}</label>
      <p-dropdown
        id="status"
        [options]="statuses"
        [(ngModel)]="selectedStatus"
        (onChange)="onStatusChange($event)"
        [showClear]="true"
        dataKey="codRuleState"
        optionLabel="ruleState"
        [disabled]="shouldDisableAreaAndStatus"
      ></p-dropdown>
    </div>
    <!-- element -->
    <div class="filter-item">
      <div class="horizontal">
        <div>
          <label for="element">{{ "WXRL.RULE.ELEMENT" | translate }}</label>
          <p-dropdown
            id="element"
            [options]="subjectTypes"
            [(ngModel)]="selectedSearchFor"
            (onChange)="onSearchForChange($event)"
            [placeholder]="'WXRL.SELECT_ELEMENT' | translate"
            dataKey="codSubjectType"
            optionLabel="subjectType"
          ></p-dropdown>
        </div>
        <div>
          <label for="subject" *ngIf="!isReglaSearch"></label>
          <label for="subject" *ngIf="isReglaSearch"></label>
          <p-dropdown
            *ngIf="!isReglaSearch"
            id="subject"
            [options]="subjects"
            [(ngModel)]="selectedSubject"
            [filter]="true"
            [filterBy]="'label'"
            [placeholder]="'WXRL.LOG.SEARCH' | translate"
            dataKey="value"
            optionLabel="label"
            [showClear]="true"
          ></p-dropdown>
          <input
            maxlength="6"
            pInputText
            *ngIf="isReglaSearch"
            id="subject"
            [(ngModel)]="ruleText"
            [placeholder]="'WXRL.SEARCH_BY_RULE_NUMBER_PLACEHOLDER' | translate"
            [style]="{ width: '100%' }"
            (keyup.enter)="onSearch()"
          />
        </div>
      </div>
    </div>

    <!-- trigger/isContained radio buttons-->
    <div class="filter-end">
      <div class="filter-item trigger">
        <p-radioButton
          name="trigger"
          value="Desencadenante"
          [(ngModel)]="selectedTrigger"
          (onChange)="onTriggerChange($event)"
          [label]="'WXRL.TRIGGER.DESENCADENANTE' | translate"
          [disabled]="shouldDisableAreaAndStatus"
        ></p-radioButton>
        <p-radioButton
          name="trigger"
          value="Contiene"
          [disabled]="!allowsTrigger || shouldDisableAreaAndStatus"
          [(ngModel)]="selectedTrigger"
          (onChange)="onTriggerChange($event)"
          [label]="'WXRL.TRIGGER.CONTINENTE' | translate"
        ></p-radioButton>
      </div>
      <!-- search p-button -->
      <button
        pButton
        [label]="'WXRL.LOG.SEARCH' | translate"
        icon="pi pi-search"
        (click)="onSearch()"
        class="search-button"
      ></button>
    </div>
  </div>
</div>
